import db from '@/firebase/init'
import firebase from 'firebase'

/**
 * firestore.rules read the caller's church from userAccess/{uid}, which the
 * syncUserAccess function copies from the users doc (GitHub #132). After a
 * church is set, church reads and writes are refused until that copy lands,
 * so wait for it.
 *
 * Resolves true once userAccess has the church, false after the timeout.
 */
export function waitForUserAccess(uid, cid, timeoutMs = 15000) {
  return new Promise((resolve) => {
    let finished = false
    let stop = null
    const finish = (ok) => {
      if (finished) return
      finished = true
      clearTimeout(timer)
      if (stop) stop()
      resolve(ok)
    }
    const timer = setTimeout(() => finish(false), timeoutMs)
    stop = db
      .collection('userAccess')
      .doc(uid)
      .onSnapshot(
        (snap) => {
          if (snap.exists && snap.get('cid') === cid) finish(true)
        },
        () => finish(false)
      )
    if (finished) stop()
  })
}

/**
 * Only the server sets a user's church (GitHub #147). On first sign-in, or for
 * an admin profile without a church, the assignSignInChurch function joins the
 * church from the user's invite or from the church's admin email, and writes
 * userAccess before it returns.
 *
 * Resolves the user's church cid, or null when there is none to set.
 */
export async function assignSignInChurch() {
  try {
    const res = await firebase
      .app()
      .functions('us-central1')
      .httpsCallable('assignSignInChurch')()
    return res?.data?.cid || null
  } catch (err) {
    console.warn('assignSignInChurch failed', err)
    return null
  }
}
